import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Emergent"
});
const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1610_71937)" }, [
  /* @__PURE__ */ createElementVNode("path", {
    d: "M17.6585 14.8579L11.3868 3.996C10.6197 2.668 9.36601 2.668 8.59909 3.996L2.32735 14.8579C1.56044 16.1873 2.18786 17.2717 3.72062 17.2717H16.2652C17.798 17.2717 18.4248 16.1872 17.6585 14.8579ZM9.13152 7.07797C9.35689 6.8343 9.64342 6.71244 9.99287 6.71244C10.3425 6.71244 10.6288 6.83301 10.8544 7.07309C11.0785 7.31371 11.1905 7.61463 11.1905 7.97649C11.1905 8.28782 10.7227 10.5772 10.5666 12.2427H9.43976C9.30289 10.5772 8.79524 8.28782 8.79524 7.97649C8.79527 7.62012 8.90748 7.32044 9.13152 7.07797ZM10.8386 14.9975C10.6015 15.2284 10.3194 15.3434 9.99295 15.3434C9.66653 15.3434 9.38436 15.2284 9.14734 14.9975C8.91098 14.7672 8.7935 14.4882 8.7935 14.1605C8.7935 13.8346 8.91098 13.5526 9.14734 13.3162C9.38436 13.0798 9.66653 12.9615 9.99295 12.9615C10.3194 12.9615 10.6015 13.0798 10.8386 13.3162C11.0748 13.5526 11.1926 13.8346 11.1926 14.1605C11.1926 14.4882 11.0748 14.7672 10.8386 14.9975Z",
    fill: "#737E99"
  })
], -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("defs", null, [
  /* @__PURE__ */ createElementVNode("clipPath", { id: "clip0_1610_71937" }, [
    /* @__PURE__ */ createElementVNode("rect", {
      width: "20",
      height: "20",
      fill: "white"
    })
  ])
], -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var emergent = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { emergent as default };
